import {
  ADD_APPLIED_COMP_CARD,
  CLEAR_SEARCH_COMP_CARDS,
  DELETE_APPLIED_COMP_CARD,
  SEARCH_COMP_CARDS,
  SEARCH_COMP_CARDS_FULFILLED,
  SEARCH_COMP_CARDS_REJECTED,
  UPDATE_APPLIED_COMP_CARD,
  RESET_APPLIED_COMP_CARDS,
} from './types';

const initialState = {
  appliedCompCards: [],
  selectedCompCard: undefined,
  searchValue: '',
  searchCompCardsState: {
    isPending: false,
    apiError: undefined,
    validationError: undefined,
  },
};

export function searchCompCardsReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_COMP_CARDS:
      return {
        ...state,
        searchValue: action.payload.value,
        searchCompCardsState: {
          apiError: undefined,
          validationError: undefined,
          isPending: true,
        },
      };

    case SEARCH_COMP_CARDS_FULFILLED:
      return {
        ...state,
        selectedCompCard: action.payload.selectedCompCard,
        searchCompCardsState: {
          apiError: undefined,
          validationError: undefined,
          isPending: false,
        },
      };

    case SEARCH_COMP_CARDS_REJECTED:
      return {
        ...state,
        searchCompCardsState: {
          apiError: action.payload.apiError,
          validationError: action.payload.validationError,
          isPending: false,
        },
      };

    case CLEAR_SEARCH_COMP_CARDS:
      return {
        ...state,
        searchValue: '',
      };

    case ADD_APPLIED_COMP_CARD:
      return {
        ...state,
        appliedCompCards: [...state.appliedCompCards, action.payload],
      };

    case UPDATE_APPLIED_COMP_CARD:
      return {
        ...state,
        appliedCompCards: state.appliedCompCards.map((card) =>
          card.cardNumber === action.payload.cardNumber ? action.payload : card
        ),
      };

    case DELETE_APPLIED_COMP_CARD:
      return {
        ...state,
        appliedCompCards: state.appliedCompCards.filter(
          (card) => card.cardNumber !== action.payload
        ),
      };

    case RESET_APPLIED_COMP_CARDS:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
